<template>
  <div class="pregled-vsebine stran-brez-izbirnika">
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Moje naročnine in priključki
          </p>
        </div>
        <div style="padding-top: 10px" v-loading="nalaganje">
          <el-tabs type="border-card" @tab-click="HandleTabClick" :value="activetab">
            <el-tab-pane label="Naročnine in priključki" name="t1" ref="t1"
                         v-if="seznamNarocnin.length > 0">
              <div v-if="activetab === 't1'">
                <MojeNarocnine :izbranaStranka="izbranaStranka" :narocnine="seznamNarocnin"
                               v-on:osveziVsePodatke="PridobiVsePodatke"
                               v-on:odpriTabStoritve="SpremeniTab"
                               v-on:osveziIzbiroStranke="OsveziIzbiroStranke"/>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Naročene storitve" name="t2" ref="t2"
                         v-if="seznamNarocnin.length > 0">
              <div v-if="activetab === 't2'">
                <div class="odmiki-narocene-storitve">
                  <p class="navadno-besedilo">
                    V pregledu naročenih storitev je izpis vaših naročenih storitev. <br>
                    Nastavitve posameznih storitev lahko urejate v meniju 'Nastavitve',
                    spremembe naročenih storitev pa v zavihku 'Naroči'.
                  </p>
                </div>
                <div class="odmik-izbirnikov-pregleda narocene-storitve-pregled">
                  <el-form label-width="135px" class="forma-uporabnik nova-vrstica-forma"
                           :label-position="formaOrientacija">
                    <el-form-item label="Izberite naročnino">
                      <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka"/>
                    </el-form-item>
                    <el-form-item label="Izberite priključek">
                      <IzbirnikPrikljuckaSelect
                        @novIzbranPrikljucek="izbranPrikljucek = $event"
                        :izbranPrikljucek="izbranPrikljucek"
                        :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
                      />
                    </el-form-item>
                  </el-form>
                  <NaroceneStoritve
                      :seznamPrikljuckov="seznamVsehPrikljuckov"
                      :izbranPrikljucek="izbranPrikljucek"
                      :izbranaStranka="izbranaStranka"
                      :izbranSap="izbranSap"/>
                </div>
              </div>
              <div v-else style="padding-top: 20px">
                <p class="navadno-besedilo">
                  <b>
                    Ni priključkov za pregled
                  </b>
                </p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Dodajanje naročnin" name="t3" ref="t3">
              <div v-if="activetab === 't3'">
                <DodajanjeNarocnin
                  v-on:osveziPodatke="PridobiVsePodatke()"
                  :seznamPrikljuckov="seznamVsehPrikljuckov"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {Input, Button, MessageBox, Tabs, TabPane, Option} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import MojeNarocnine from './DodajanjeNarocnin/MojeNarocnine'
import NaroceneStoritve from './DodajanjeNarocnin/NaroceneStoritve'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import {
  MixinGetUserData
} from '../../../../assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/PridobitevUporabniskihPodatkov'
import DodajanjeNarocnin from './DodajanjeNarocnin/DodajanjeNarocnin'
import MenuAndRoutesBuilder from '../../../../assets/js/menuAndRoutesBuilder'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PrikljucekStatusEnum} from '../../../../assets/js/Enum/PrikljucekStatusEnum'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {PrivzetaVrednostTipEnum} from '../../../../assets/js/Enum/PrivzetaVrednostTipEnum'
import PrivzetaVrednostLogic from '../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'

export default {
  name: 'narocnine',
  mixins: [GetPodatkiIzbirnika, PrikazVsebine, MixinGetUserData],
  data () {
    return {
      clientAgent: null,
      nalaganje: true,
      activetab: 't1',
      izbranaStranka: '',
      izbranPrikljucek: null,
      izbranSap: '',
      menuAndRoutesBuilder: MenuAndRoutesBuilder.getInstance(),
      formaOrientacija: 'left',
      mejnaSirina: 800,
      seznamVsehPrikljuckov: [],
      skrijOstaleTabe: true,
      veljavniStatusZaPrikaz: [],
      seznamPrikljuckovGrupirano: [],
      seznamNarocnin: []
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    UrejenSeznamPrikljuckov,
    IzbirnikStranke,
    DodajanjeNarocnin,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Option.name]: Option,
    [MessageBox.name]: MessageBox,
    [Button.name]: Button,
    [Input.name]: Input,
    'MojeNarocnine': MojeNarocnine,
    'NaroceneStoritve': NaroceneStoritve
  },
  watch: {
    orientacijaPrikazaTabele (val) {
      this.prikazTabele = val
    },
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    seznamNarocnin () {
      if (this.seznamNarocnin.length !== 0) {
        this.activetab = 't1'
      } else {
        this.activetab = 't3'
      }
      this.nalaganje = false
      this.menuAndRoutesBuilder.RetrieveRoutesAndSideBarLinks()
    },
    activetab (val) {
      if (this.skrijOstaleTabe === false) {
        this.activetab = 't3'
      }
    }
  },
  mounted () {
    this.veljavniStatusZaPrikaz = [
      {
        'idStatus': PrikljucekStatusEnum.VKLOPLJEN,
        'naziv': 'Vklopljen'
      },
      {
        'idStatus': PrikljucekStatusEnum.MIROVANJE,
        'naziv': 'Mirovanje'
      },
      {
        'idStatus': PrikljucekStatusEnum.ZACASEN_IZKLOP_SU2,
        'naziv': 'Začasen izklop'
      },
      {
        'idStatus': PrikljucekStatusEnum.PRIKLOP_V_TEKU,
        'naziv': 'Priklop v teku'
      }
    ]
    this.clientAgent = new ClientAgent()
    this.PridobiVsePodatke()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    SpremeniTab () {
      this.activetab = 't2'
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.GetPrikljuckiDovoljenja(podatkiStranke.id_stranka)
      }
    },
    OsveziIzbiroStranke (stranka, status) {
      this.izbranaStranka = stranka
    },
    PridobiVsePodatke () {
      this.nalaganje = false
      this.seznamNarocnin = []
      this.GetSeznamNarocnin()
    },
    PrenosniPodatkiStranke (seznam) {
      this.seznamNarocnin = seznam
      if (this.seznamNarocnin.length === 0) {
        this.HandleTabClick('t3')
      }
      this.nalaganje = false
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissions[]=PRIKLJUCKI']
        param.push('permissions[]=PREPAID_PRIKLJUCKI')
        this.clientAgent.postWsRequest(
          this,
          'permissions/all',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.results.PRIKLJUCKI.additionalData,
        podatki.results.PREPAID_PRIKLJUCKI.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      let shranjenPrivzetPrikljucek = PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK)
      if (list.find(x => x.id_prikljucek === shranjenPrivzetPrikljucek)) {
        this.izbranPrikljucek = shranjenPrivzetPrikljucek
      } else {
        list.filter(x => x.tip_prikljucka === 'FIX').forEach(prikljucek => {
          this.izbranPrikljucek = prikljucek.id_prikljucek
        })
      }
      if (this.izbranPrikljucek === '') {
        this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      }
      this.seznamPrikljuckovGrupirano = groupedList
    },
    ErrPrikljuckiDovoljenja (podatki) {
      this.ShowWarningMessage(podatki)
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
      if (this.activetab === 't1') {
        if (this.seznamNarocnin.length > 1) {
          this.izbranaStranka = ''
        }
      }
    }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/narocnine.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Narocnine.vue